export const postToGTM = (...params) => window.dataLayer.push(...params);
